import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import PublicStudentListPopup from './PublicStudentListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { useNavigate } from 'react-router-dom'; 

const StudentLeaveFormPage = () => {
    const [cost, setCost] = useState('');
    const [receiver, setReceiver] = useState(null);
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [leaveMonth, setLeaveMonth] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/utils/getLeaveCost')
          .then(response => setCost(response.data.data.cost))
          .catch(error => console.error('Error fetching program list:', error));
          setPaymentAmount(formatCurrency(cost.cost_amount));  
    }, []);

    useEffect(() => {
          setPaymentAmount(formatCurrency(cost.cost_amount));  
    }, [cost]);
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const handleSelectStudent = (student) => {
        setReceiver(student);
        setShowStudentPopup(false);
    };

    const validateForm = () => {
        const errors = {};
    
        // Cek jika field kosong
        
        if (!paymentMethod) errors.payment_method = 'Payment Method is required';
        if (!leaveMonth) errors.leaveMonth = 'Leave Month is required';
        if (!receiver) errors.receiver = 'Student is required';
        if (!paymentDate) errors.paymentDate = 'Payment Date is required';
        if (paymentAmount==0) errors.paymentAmount = 'Payment amount is required';
        if (!description) errors.description = 'Description is required';

        return errors;
    };
   
    const handleSubmit = () => {
        
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            const studentData = {
                data: {
                    studentData: {
                        student_id: receiver.student_id, 
                        leave_month: leaveMonth,
                        payment_amount: cost.cost_amount,
                        payment_method: paymentMethod,
                        payment_date: paymentDate,
                        description: description
                    },
                },
            };

            console.log(studentData);

            api.post(`student/leave/save`, studentData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
                
            })
            .catch(error => {
                console.error('Error adding student:', error);
                return;
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    
        

    };


    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Leave Form</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.receiver && 
                                    <td>
                                        <div className="error-message">{errors.receiver}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <h3 className="section-header">Class Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Leave Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="leaveMonth"
                                            value={leaveMonth} 
                                            onChange={e => setLeaveMonth(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    {errors.leaveMonth && 
                                    <td>
                                        <div className="error-message">{errors.leaveMonth}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Amount</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="number"     
                                            value={paymentAmount}  
                                            readOnly/>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.paymentAmount && 
                                    <td>
                                        <div className="error-message">{errors.paymentAmount}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Date</label>
                                    </td>
                                    <td>
                                        <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.paymentDate && 
                                    <td>
                                        <div className="error-message">{errors.paymentDate}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Method</label>
                                    </td>
                                    <td>
                                        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.payment_method && 
                                    <td>
                                        <div className="error-message">{errors.payment_method}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Description</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <textarea value={description} onChange={(e) =>setDescription(e.target.value)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.description && 
                                    <td>
                                        <div className="error-message">{errors.description}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>

            {showStudentPopup && (
                <StudentListPopup 
                    onSelectStudent={handleSelectStudent} 
                    onClose={() => setShowStudentPopup(false)} 
                />
            )}
        </div>
    );
};

export default StudentLeaveFormPage;
